"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentDmpApi = exports.listValues = exports.list = void 0;
const list = (caller) => (options) => {
    const { accountId, dmpId, segmentType } = options;
    const query = {
        _max_per_page: 0,
    };
    const url = `/api/accounts/${accountId}/dmps/${dmpId}/${segmentType}`;
    return caller(url).get(query);
};
exports.list = list;
const listValues = (caller) => (options) => {
    const { accountId, dmpId, segmentId } = options;
    const query = {
        _max_per_page: 0,
    };
    const url = `/api/accounts/${accountId}/dmps/${dmpId}/segments/${segmentId}/values`;
    return caller(url).get(query);
};
exports.listValues = listValues;
const segmentDmpApi = (caller) => ({
    list: (0, exports.list)(caller),
    listValues: (0, exports.listValues)(caller),
});
exports.segmentDmpApi = segmentDmpApi;
//# sourceMappingURL=api.js.map